import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { InsuranceQuestionnaireService } from 'src/app/services/insurance-questionnaire.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class InsuranceQuestionnaireStartEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private router: Router,
    public toastr: ToastrService,
    private service: InsuranceQuestionnaireService) {
  }

  submit$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.SubmitRequestAction),
    switchMap((action: any) => this.service.submit(action.accountId, action.data)),
    map((data: any) => {
      return ActionsList.SubmitResponseAction({ data: data.data });
    })
  ));



  confirm$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.ConfirmRequestAction),
    switchMap((action: any) => this.service.confirm(action.accountId, action.data)),
    map((data: any) => {
      this.service.showOk(data.message);
      return ActionsList.ConfirmResponseAction({ data: data.data });
    })
  ));

}
